import { useFormat } from '@ideavivat/vivat-2';

export default {
  types: {
    _increment: {
      name: 'ลำดับ',
      width: '4rem',
      class: 'text-center',
    },
    po_code: {
      name: 'เลขที่รายการ',
      width: '6rem',
      // eslint-disable-next-line
      filter: (val: string) => val ? val : '-',
    },
    bom_name: {
      name: 'Job no.',
      width: '16rem',
      // eslint-disable-next-line
      filter: (val: string) => val ? val : '-',
    },
    job_no: {
      name: 'Job no.',
      width: '8rem',
      // eslint-disable-next-line
      filter: (val: string) => val ? val : '-',
    },
    code: {
      name: 'รหัสชิ้นส่วน',
      width: '1fr',
    },
    name: {
      name: 'ชื่อชิ้นส่วน',
      width: '1.5fr',
    },
    brand: {
      name: 'ยี่ห้อ',
      width: '1fr',
    },
    latest_price: {
      name: 'ราคาที่ซื้อล่าสุด',
      width: '6rem',
      class: 'text-right',
      // eslint-disable-next-line
      filter: (val: any, row: any) => row.item.poHistory ? row.item.poHistory.lates_price : '-',
    },
    amount: {
      name: 'จำนวน',
      width: '6rem',
      class: 'text-right',
      filter: (val: string) => parseFloat(val || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    unit: {
      name: 'หน่วย',
      width: '3rem',
      // eslint-disable-next-line
      filter: (val: string) => val ? val : '-',
    },
    target_date: {
      name: 'กำหนดส่ง',
      width: '12rem',
      class: 'text-right',
      // eslint-disable-next-line
      filter: (val: string) => val ? useFormat.date(val).displayShortThaiDate() : 'ไม่ระบุ',
    },
  },
};
